import type { IFilterPanelBaseFilterDeps, IFilterPanelBaseFilterModel } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";

import type { IIabCategoriesFilterDto } from "../../types/commonFiltersDto";
import type { IIabCategoriesDescriptionDto, IIabCategoryItemDescriptionDto } from "../../types/descriptionDto";

export default class IabCategoriesFilter
    extends FilterPanelBaseFilter<IIabCategoriesFilterDto, readonly IIabCategoryItemDescriptionDto[]>
    implements IFilterPanelBaseFilterModel<IIabCategoriesFilterDto, readonly IIabCategoryItemDescriptionDto[]>
{
    constructor({ options }: IFilterPanelBaseFilterDeps<IIabCategoriesFilterDto, IIabCategoriesDescriptionDto>) {
        const { categories } = options;

        super({ options: categories });
    }
}
